/* Kidis Warenkorb – ohne App. Produkt fliegt in den Warenkorb, Drawer nur per Klick auf das Symbol. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const host = document.getElementById('shopify-section-kidis-cart');
  if (!host) return;
  const fly = host.querySelector('[data-kc]')?.dataset.fly !== 'false';
  const nativeFetch = window.fetch.bind(window);
  let lastClick = null;
  let busyOwn = 0;

  const kc = () => host.querySelector('[data-kc]');
  const open = () => { kc()?.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; host.querySelector('.kc__panel')?.focus(); };
  const close = () => { kc()?.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
  const isOpen = () => kc()?.classList.contains('is-open');

  async function refresh() {
    const wasOpen = isOpen();
    const res = await nativeFetch(`${root}?section_id=kidis-cart`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-kc]');
    if (fresh) {
      if (wasOpen) fresh.classList.add('is-open');
      kc().replaceWith(fresh);
    }
    const cart = await (await nativeFetch(`${root}cart.js`)).json();
    document.querySelectorAll('.cart-link__bubble').forEach((b) => {
      b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      const n = b.querySelector('.cart-link__bubble-num');
      if (n) n.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }

  async function api(path, body) {
    busyOwn++;
    kc()?.classList.add('is-busy');
    try {
      const res = await nativeFetch(root + path, {
        method: 'POST',
        headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body instanceof FormData ? body : JSON.stringify(body)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Fehler');
      return data;
    } finally {
      busyOwn--;
      kc()?.classList.remove('is-busy');
    }
  }

  /* Fliegendes Produktbild */
  function flyToCart() {
    const target = [...document.querySelectorAll('#HeaderCartTrigger .cart-link, #HeaderCartTrigger, .site-header a[href$="/cart"], .js-drawer-open-cart')].find(e => e.offsetWidth);
    if (!target) return;
    const scope = lastClick?.closest('.product-grid-item, .grid-item, product-section, .product-section, [data-product-id], .product-single, form') || document;
    let img = scope.querySelector('img');
    if ((!img || !img.offsetWidth) && lastClick) img = document.querySelector('.product__main-photos img, .product-single__media img, main img');
    const t = target.getBoundingClientRect();
    if (!img || !img.offsetWidth || !fly) return bump(target);
    const s = img.getBoundingClientRect();
    const size = Math.min(s.width, s.height, 140);
    const clone = img.cloneNode();
    clone.removeAttribute('srcset'); clone.removeAttribute('sizes'); clone.removeAttribute('loading');
    clone.src = img.currentSrc || img.src;
    clone.className = 'kc-fly';
    Object.assign(clone.style, { left: `${s.left + s.width / 2 - size / 2}px`, top: `${s.top + s.height / 2 - size / 2}px`, width: `${size}px`, height: `${size}px` });
    document.body.appendChild(clone);
    const dx = t.left + t.width / 2 - (s.left + s.width / 2);
    const dy = t.top + t.height / 2 - (s.top + s.height / 2);
    clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 90}px) scale(.7) rotate(-8deg)`, opacity: 1, offset: 0.45 },
      { transform: `translate(${dx}px, ${dy}px) scale(.12)`, opacity: 0.4 }
    ], { duration: 1600, easing: 'cubic-bezier(.45,.05,.35,1)' }).onfinish = () => { clone.remove(); bump(target); };
  }
  function bump(el) {
    if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
    el.animate([
      { transform: 'scale(1) rotate(0)' }, { transform: 'scale(1.45) rotate(-14deg)', offset: .15 },
      { transform: 'scale(1.45) rotate(14deg)', offset: .3 }, { transform: 'scale(1.3) rotate(-10deg)', offset: .45 },
      { transform: 'scale(1.2) rotate(8deg)', offset: .6 }, { transform: 'scale(1.1) rotate(-4deg)', offset: .78 },
      { transform: 'scale(1) rotate(0)' }
    ], { duration: 900, easing: 'ease-out' });
    el.classList.remove('kc-bump'); void el.offsetWidth; el.classList.add('kc-bump');
  }

  async function added() {
    if (!fly) { await refresh(); open(); return; }
    flyToCart();
    await refresh();
  }

  document.addEventListener('pointerdown', (e) => { lastClick = e.target; }, true);

  /* Klassische Produktformulare abfangen (statt Weiterleitung zur Warenkorbseite) */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const inDrawer = host.contains(form);
    if (e.submitter) lastClick = e.submitter;
    try {
      await api('cart/add.js', new FormData(form));
      if (inDrawer) await refresh(); else await added();
    } catch (err) {
      alert(err.message);
    }
  }, true);

  /* Andere Hinzufügen-Wege des Themes (Schnellkauf, Mengenwahl) erkennen */
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (!busyOwn && res.ok && /\/cart\/(add|update|change)(\.js)?/.test(url)) {
        /\/cart\/add/.test(url) ? added() : refresh();
      }
    } catch (_) {}
    return res;
  };

  /* Warenkorb-Symbol öffnet den Drawer */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('#HeaderCartTrigger, a.site-nav__link--cart, [href$="/cart"].js-drawer-open-cart');
    if (trigger && !host.contains(trigger)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      return;
    }
    if (!host.contains(e.target)) return;
    if (e.target.closest('[data-kc-close]')) return close();
    const q = e.target.closest('[data-kc-qty]');
    if (q) return changeLine(q.closest('[data-line]').dataset.line, +q.dataset.kcQty);
    const rm = e.target.closest('[data-kc-remove-code]');
    if (rm) return setDiscount(currentCodes().filter((c) => c.toLowerCase() !== rm.dataset.kcRemoveCode.toLowerCase()).join(','));
  }, true);

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) close(); });

  host.addEventListener('change', (e) => {
    if (e.target.matches('[data-kc-input]')) changeLine(e.target.closest('[data-line]').dataset.line, Math.max(0, parseInt(e.target.value, 10) || 0));
    if (e.target.matches('[data-kc-note]')) api('cart/update.js', { note: e.target.value });
  });

  host.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-kc-discount]');
    if (!f) return;
    e.preventDefault();
    const code = f.code.value.trim();
    if (!code) return;
    setDiscount([...currentCodes(), code].join(','), code);
  });

  function currentCodes() {
    return [...host.querySelectorAll('[data-kc-remove-code]')].map((b) => b.dataset.kcRemoveCode);
  }

  async function changeLine(line, quantity) {
    try { await api('cart/change.js', { line: +line, quantity }); } catch (err) { showError(err.message); }
    await refresh();
  }

  async function setDiscount(codes, added) {
    try {
      const cart = await api('cart/update.js', { discount: codes });
      await refresh();
      if (added) {
        const ok = (cart.discount_codes || []).some((d) => d.code.toLowerCase() === added.toLowerCase() && d.applicable);
        if (!ok) showError('Dieser Rabattcode ist nicht gültig oder gilt nicht für deinen Warenkorb.');
      }
    } catch (err) { showError(err.message); }
  }

  function showError(msg) {
    const el = host.querySelector('[data-kc-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  window.KidisCart = { open, close, refresh };
})();
